import { BALANCE, CREDIT, DEPOSIT, DEPOSIT1, DEPOSIT2, FULL } from '../../consts/paymentTypes';

const PAID_BG = '#DCFCE6';
const PAID_FG = '#166534';
const MUTED_BG = '#EFEFEF';

const formatRounded = (value) => `$${Math.round(Number(value) || 0).toLocaleString('en-US')}`;

/**
 * Compact milestone chips for the Payment History column (Manus prototype).
 * Paid-detection matches the legacy PaymentBar exactly: a chip turns green
 * once its milestone is fully covered by recorded payments.
 */
export const MilestoneChips = ({ po, testId }) => {
    const payments = po.payments || [];
    const milestonesAmounts = po.paymentBarMilestones || {};
    const percentages = po.paymentBarPercentages || {};

    const getPaidAmount = (type) => {
        const amount = Number(payments.find((payment) => payment.type === type)?.amount);
        return Number.isNaN(amount) ? 0 : amount;
    };

    const hasFullPaid = !!getPaidAmount(FULL);
    const depositPaidInOnePayment = !!getPaidAmount(DEPOSIT);
    const hasPaidDeposit1 = !!getPaidAmount(DEPOSIT1);
    const hasPaidDeposit2 = !!getPaidAmount(DEPOSIT2);

    const chips = [];
    if (percentages?.deposit) {
        chips.push({
            key: 'deposit',
            label: 'Deposit',
            amount: Number(milestonesAmounts[DEPOSIT]) || 0,
            paid: hasFullPaid || depositPaidInOnePayment || (hasPaidDeposit1 && hasPaidDeposit2),
            half: !hasFullPaid && !depositPaidInOnePayment && (hasPaidDeposit1 !== hasPaidDeposit2)
        });
    }
    if (percentages?.balance) {
        chips.push({
            key: 'balance',
            label: 'Balance',
            amount: Number(milestonesAmounts[BALANCE]) || 0,
            paid: hasFullPaid || !!getPaidAmount(BALANCE),
            half: false
        });
    }
    if (percentages?.credit) {
        chips.push({
            key: 'credit',
            label: 'Credit',
            amount: Number(milestonesAmounts[CREDIT]) || 0,
            paid: hasFullPaid || !!getPaidAmount(CREDIT),
            half: false
        });
    }

    if (chips.length === 0) return null;

    return (
        <div className="flex items-start gap-2 flex-wrap" data-testid={testId}>
            {chips.map((chip) => {
                const style = chip.paid
                    ? { backgroundColor: PAID_BG, color: PAID_FG }
                    : chip.half
                        ? { background: `linear-gradient(to right, ${PAID_BG} 50%, ${MUTED_BG} 50%)`, color: '#111827' }
                        : { backgroundColor: MUTED_BG, color: '#111827' };
                return (
                    <div key={chip.key} className="flex flex-col items-center gap-0.5">
                        <span
                            className="px-2 py-0.5 rounded-md text-[14px] font-semibold tabular-nums whitespace-nowrap"
                            style={style}
                        >
                            {formatRounded(chip.amount)}
                        </span>
                        <span className="text-[12px] text-gray-500">{chip.label}</span>
                    </div>
                );
            })}
        </div>
    );
};
